@if (list) {
    @for (item of list; track item; let i = $index) {
        @if (i < limit || showAll) {
            <li>
                <ng-template
                    [ngTemplateOutlet]="template"
                    [ngTemplateOutletContext]="{ $implicit: item }"
                ></ng-template>
            </li>
        }
    }
    @if (list.length > limit) {
        <a
            [innerHTML]="(showAll ? 'showMore.less' : 'showMore.more') | translate: { more: list.length - limit }"
            (click)="toggle()"
        >
        </a>
    }
}
